import { Text } from '@bancobarigui/barihaus';
import { formatarNumero } from '../shared/formatters';
import * as styles from '../CardHomogeneizacao/styles';

interface CoeficienteVariacaoDisplayProps {
  coeficienteVariacao: number;
}

export function CoeficienteVariacaoDisplay({ coeficienteVariacao }: CoeficienteVariacaoDisplayProps) {
  const isAlto = coeficienteVariacao > 30;

  return (
    <Text style={isAlto ? styles.coeficienteVariacaoAltoStyle : styles.coeficienteVariacaoBaixoStyle}>
      {formatarNumero(coeficienteVariacao, 4)}%
    </Text>
  );
}
